// extracted by mini-css-extract-plugin
export default {"container":"vM-z","darkBackground":"wM-z","whiteBackground":"xM-z","headerButton":"yM-z","calloutHeading":"zM-z","calloutSubHeading":"AM-z"};